"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _Popper = require("../../Utils/Popper");
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styledSystem = require("styled-system");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Tooltip = function Tooltip(_ref) {
  var children = _ref.children,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? 'auto' : _ref$placement,
    title = _ref.title,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'darkSilver' : _ref$variant;
  return /*#__PURE__*/_react["default"].createElement(StyledTooltip, {
    variant: variant,
    title: title,
    placement: placement
  }, children);
};
var StyledTooltip = (0, _styledComponents["default"])(_Popper.Popper)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t/* position: relative; */\n\t.popper-element {\n\t\t/* position: absolute; */\n\t\t/* margin: 1rem; */\n\t\twidth: fit-content;\n\t\tborder-radius: 5px;\n\t\tfont-size: 0.625rem;\n\t\tpadding: 0.25rem;\n\t\t", "\n\t}\n"])), (0, _styledSystem.variant)({
  scale: 'buttonColors',
  prop: 'variant'
}));
var _default = Tooltip;
exports["default"] = _default;